import * as React from 'react';

import styles from 'src/components/dataSourceSelection/formField.module.scss';

export type FormFieldProps = {
  /** The unique ID for the input element */
  id: string;
  /** The label text to display */
  label: string;
  /** Whether the field is required */
  required?: boolean;
  /** The form input element(s) */
  children: React.ReactNode;
};

export const FormField: React.VFC<FormFieldProps> = ({
  id,
  label,
  required = false,
  children,
}) => {
  return (
    <div className={styles.formField}>
      <label
        className={
          required ? styles.formFieldLabelRequired : styles.formFieldLabel
        }
        htmlFor={id}
      >
        {label}
      </label>
      {children}
    </div>
  );
};
